

export class UserSelectByCompanyDetailsIdData implements IUserSelectByCompanyDetailsIdData {
    /** The auto-generated id of the user master */
    user_id!: number;
    /** The user type name with 255 character limit */
    user_name!: string;
    /** The user mobile number with 13 character limit */
    mobile_no!: string;

    constructor(data?: IUserSelectByCompanyDetailsIdData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_id = _data["user_id"];
            this.user_name = _data["user_name"];
            this.mobile_no = _data["mobile_no"];
        }
    }

    static fromJS(data: any): UserSelectByCompanyDetailsIdData {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectByCompanyDetailsIdData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_id"] = this.user_id;
        data["user_name"] = this.user_name;
        data["mobile_no"] = this.mobile_no;
        return data; 
    }
}

export interface IUserSelectByCompanyDetailsIdData {
    /** The auto-generated id of the user master */
    user_id: number;
    /** The user type name with 255 character limit */
    user_name: string;
    /** The user mobile number with 13 character limit */
    mobile_no: string;
}

